<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name':'client-content-strings-create', params: { clientId: clientId }}">Create string</router-link>
            </div>
        </div>

        <content-string-list :items="items" :reload="reload" />
    </div>
</template>
<script>
import contentService from '../../../../../services/content.service'

import ContentStringList from '../../../../common/content/string/content-string-list.vue'

export default {
    name: 'system-content-strings',
    components: { ContentStringList },
    data() {
        return {
            items: []
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async created() {
        await this.reload();
    },
    methods: {
        async reload() {
            this.items = await contentService.listStrings(this.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/strings/list.vue